<script>
	import Router from "svelte-spa-router";
	import { RUTAS_COMPONENTES, RUTAS_HUMAN } from "./utils/ROUTING.js";
</script>

<main>
	<div class="col-12 bsr">
		test
	</div>
	<h1>Pagos.Viewdevs.com.ar</h1>
	<main>
		<Router routes={RUTAS_COMPONENTES} />
	</main>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>